import Vue from 'vue';
import Vuex from 'vuex';
import async from '@/store/modules/async';
import axios from 'axios';
import replaceAccents from '@/includes/textHelpers';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export const state = {
  token: '',
  rut: 0,
  dv: '',
  names: '',
  surname: '',
  secondSurname: '',
  idRefAddress: 0,
  isLogged: false,
};

export default new Vuex.Store({
  modules: {
    async,
  },
  actions,
  getters,
  mutations,
  state,
  strict: process.env.NODE_ENV !== 'production',
});

axios.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    Object.assign(config.headers, {
      Authorization: `${state.token}`,
    });
  }
  if (!config.headers['X-Rut'] && state.rut !== 0) {
    Object.assign(config.headers, {
      'X-Rut': `${state.rut}`,
      'X-Dv': `${state.dv}`,
    });
  }
  if (!config.headers['X-Nombres'] && state.names !== '') {
    Object.assign(config.headers, {
      'X-Nombres': `${replaceAccents(state.names)}`,
      'X-Apellidos': `${replaceAccents(state.surname)}`,
    });
  }
  return config;
}, err => Promise.reject(err));
